var exports = {
  "sj": "PromptsGrid__2fnm0J",
  "Ej": "PromptItem__JqO6rV",
  "XG": "Prompt__L2pvSu",
};

module.exports = exports;
